var map = {
	"./accuracy.svg": 44,
	"./age.svg": 54,
	"./altitude.svg": 61,
	"./aroma.svg": 26,
	"./color.svg": 57,
	"./contact.svg": 64,
	"./date-harvest.svg": 59,
	"./email.svg": 62,
	"./facebook.svg": 65,
	"./fbmessenger.svg": 127,
	"./feedback.svg": 28,
	"./grade.svg": 56,
	"./instagram.svg": 66,
	"./line.svg": 68,
	"./localname.svg": 55,
	"./origin.svg": 53,
	"./service.svg": 45,
	"./shape.svg": 60,
	"./share.svg": 69,
	"./size.svg": 58,
	"./taste.svg": 27,
	"./telegram.svg": 128,
	"./texture.svg": 25,
	"./upload.svg": 47,
	"./value.svg": 46,
	"./website.svg": 63,
	"./wechat.svg": 70,
	"./whatsapp.svg": 129,
	"./youtube.svg": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;